import { Component, Input } from "@angular/core";

@Component({
  selector: "med-tab",
  templateUrl: "./med-tab.component.html",
  styleUrls: ["./med-tab.component.scss"],
})
export class MedTabComponent {
  @Input() active?: boolean = false;

  get classList(): string {
    return this.active ? "active" : "";
  }
}
